import React from 'react';
import i18n from 'i18n-react';

import { FastFacts, ContentHeader, BackButton } from 'C4';
import PropTypes from 'prop-types';

import { HashLink as Link } from 'react-router-hash-link';

const FastFactsView = (props) => {
  const { match: { params } } = props;
  return (
    <div className="contentContainer">
      <BackButton to="/main/" />
      <ContentHeader
        header={i18n.translate('nav.promote')}
        subtitle={i18n.translate('pageDescriptions.promote')}
        social
      />
      <div className="filter">
        <div className="title">Filter by brand:</div>
      </div>
      <FastFacts brand={params.brand} />
    </div>
  );
};

export default FastFactsView;

FastFactsView.propTypes = {
  match: PropTypes.shape().isRequired,
};
